<template>
  <SegmentedControl
    class="m-b-20 accounts-primary-tabs"
    aria-label="Finance control section"
    :value="changeTab"
    :options="[
      {
        label: 'Jobs Payment Detail',
        value: 'paymentDetail',
        icon: 'work_outline',
      },
      {
        label: 'Assignment Payment Details',
        value: 'advanceDetail',
        icon: 'assignment',
      },
    ]"
    @change="filterByTab"
  />
    <!-- <v-tab
      v-if="workingCountry.includes('UAE') || workingCountry.includes('KSA')"
      :href="`#customerDetail`"
      @click="filterByTab('customerDetail')"
      >Customer Receipt
    </v-tab> -->
</template>

<script>
import Loading from "vue-loading-overlay";
import { EventBus } from "../../event-bus.js";
import SegmentedControl from "@/components/Common/SegmentedControl";
export default {
  components: {
    SegmentedControl,
  },
  created() {
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = workingCountry;
    }

    EventBus.$on("countryChanged", (val) => {
      if (this.$route.path == "/accounts") {
        this.workingCountry = JSON.stringify(val);
        if (
          this.workingCountry.includes("UAE") ||
          this.workingCountry.includes("KSA")
        ) {
        } else {
          this.$router.push(`/accounts`);
        }

        this.loading = true;
      }
    });
  },
  data: () => ({
    active: "0",
    loading: true,
    workingCountry: null,
    changeTab: "paymentDetail",
  }),
  methods: {
    filterByTab(value) {
      if (value == "advanceDetail") {
        this.$router.push(`/accounts/advance`).catch(() => {});
      } else if (value == "customerDetail") {
        this.$router.push(`/accounts/customerPayment`);
      } else {
        this.$router.push(`/accounts`);
      }

      this.changeTab = value;
    },
  },
};
</script>

<style scoped>
.accounts-primary-tabs {
  background: transparent;
  margin-bottom: 0 !important;
  max-width: 100%;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  padding: 0;
  width: fit-content;
}

@media (max-width: 760px) {
  .accounts-primary-tabs {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
